import { get, post } from "./ApiService";

const BUG_META_ENDPOINT = "/bug_meta";

export const PRIORITIES = ["low", "medium", "high"];

export const PRIORITY_LABELS = {
  low: "Düşük",
  medium: "Orta",
  high: "Yüksek",
};

export const PRIORITY_COLORS = {
  low: "#64748b",
  medium: "#f59e0b",
  high: "#ef4444",
};

// Bir işin meta verisini (priority + due_date) getirir
export const getBugMeta = async (bugId) => {
  const response = await get(BUG_META_ENDPOINT, { bug_id: bugId });
  return response?.meta || null;
};

// İşin meta verisini kaydeder (upsert). dueDate boş gönderilirse temizlenir.
export const saveBugMeta = async ({ bugId, priority, dueDate } = {}) => {
  const payload = { bug_id: bugId };
  if (priority !== undefined) payload.priority = priority;
  if (dueDate !== undefined) payload.due_date = dueDate || "";

  const response = await post(BUG_META_ENDPOINT, payload);

  if (response?.status === "error") {
    throw new Error(response?.message || "Öncelik/teslim tarihi kaydedilemedi.");
  }

  return response?.meta || null;
};
